<template>
  <div class="content">
    <h1>寓喵管家隐私政策</h1>
    <div class="meta">
      <div>版本号：<strong>V2.0</strong></div>
      <div>更新日期：<strong>2026年9月20日</strong></div>
      <div>生效日期：<strong>2026年9月20日</strong></div>
    </div>

    <div class="tip">
      <p>
        <strong>【特别提示】</strong
        >本政策适用于马鞍山市微行网络科技有限责任公司（以下简称“我们”）提供的“寓喵管家”移动应用程序（以下简称“本App”）。请您在使用本App前，仔细阅读并充分理解本政策全文，特别是以<strong>加粗</strong>形式标识的条款。
      </p>
      <p>
        您点击“同意”即表示您已充分理解并同意本政策。<strong
          >在您点击同意之前，本App不会收集您的任何个人信息，也不会申请任何敏感系统权限，所接入的第三方SDK均不会初始化。</strong
        >如您不同意本政策，您可以选择“不同意”并退出本App，这不影响您通过其他合法途径获取相关服务。
      </p>
      <p>
        <strong>本政策将帮助您了解：</strong>
      </p>
      <ul class="toc">
        <li>一、我们如何收集和使用您的个人信息</li>
        <li>二、我们如何调用设备权限</li>
        <li>三、我们如何使用Cookie及同类技术</li>
        <li>四、我们如何共享、转让、公开披露您的个人信息</li>
        <li>五、我们如何存储您的个人信息</li>
        <li>六、我们如何保护您的个人信息</li>
        <li>七、您的权利</li>
        <li>八、我们如何处理未成年人的个人信息</li>
        <li>九、本政策如何更新</li>
        <li>十、如何联系我们</li>
      </ul>
    </div>

    <h2>一、我们如何收集和使用您的个人信息</h2>
    <p>
      我们仅会出于本政策所述的以下目的，收集和使用您的个人信息。<strong
        >我们遵循最小必要原则，只收集实现产品功能所必需的信息；您拒绝提供“选填信息”的，不影响您使用其他功能。</strong
      >
    </p>

    <h3>1.1 注册、登录与账号管理</h3>
    <ul>
      <li>
        <strong>手机号码（必要）</strong
        >：用于创建账号、登录、找回密码、更换手机号、接收业务通知及保障账号安全。收集方式为您主动填写并通过短信验证码校验；或在您点击“本机号码一键登录”并同意授权后，由运营商号码认证服务返回。<strong
          >手机号码属于法律法规要求的网络实名信息，拒绝提供将无法注册和使用本App。</strong
        >
      </li>
      <li>
        <strong>登录密码（必要）</strong
        >：用于账号密码登录与身份校验。密码经不可逆加密后存储，我们无法还原您的明文密码。
      </li>
      <li>
        <strong>昵称、头像（选填）</strong
        >：用于展示您的个人资料。头像可由您从相册选择或拍摄。
      </li>
    </ul>

    <h3>1.2 房源、租客与合同管理</h3>
    <ul>
      <li>
        <strong>房源与经营信息</strong
        >：您在使用房源管理、房间管理、预定、待办、抄表、账单、统计等功能时录入的房源地址、房间信息、租金与押金金额、水电读数、收支记录、备注等信息。
      </li>
      <li>
        <strong>租客信息</strong
        >：您在录入租客、签订合同时填写的租客姓名、手机号码、身份证号码、证件照片、紧急联系人等信息。
      </li>
      <li>
        <strong
          >【关于您提供他人个人信息的特别提示】您在本App中录入租客、同住人、紧急联系人等他人个人信息的，您应当事先取得该等信息主体的合法授权，并确保所提供信息的真实、合法。对于您上传的他人个人信息，您是该等信息的处理者，我们仅根据您的指示提供存储与展示等技术服务。因您未取得合法授权而引发的纠纷或损失，由您自行承担。</strong
        >
      </li>
    </ul>

    <h3>1.3 电子合同、实名认证与人脸核验</h3>
    <ul>
      <li>
        <strong>姓名、身份证号码（使用相关功能时必要）</strong
        >：仅在您使用电子合同签署、实名认证功能时收集，用于合同主体信息填写、实名核验与生成具有法律效力的电子签名。收集方式为您主动填写；或经您授权拍摄证件后，由<strong
          >本机离线文字识别</strong
        >自动填入（识别全过程在您的设备本地完成，证件图片与识别结果不会传输给识别服务提供方）。
      </li>
      <li>
        <strong>人脸信息（敏感个人信息，使用相关功能时必要）</strong
        >：<strong
          >仅在您办理实名认证或签署电子合同需要进行人脸核验时，由电子签名服务提供商杭州天谷信息科技有限公司（e签宝）在其页面内单独征得您的同意后采集并核验，用于确认您本人真实意愿。人脸信息由该服务商直接采集与处理，我们不接触、不存储您的人脸图像与人脸特征信息，仅接收核验是否通过的结果。</strong
        >您可以选择不使用人脸核验，改用其他签署方式，但可能导致电子合同无法生效。
      </li>
      <li>
        <strong>电子签名图像</strong
        >：您在签署页面手写签名时生成的签名图像，用于合同签署与存证。
      </li>
    </ul>

    <h3>1.4 会员购买与在线收款</h3>
    <ul>
      <li>
        <strong>支付信息</strong
        >：您购买会员或增值服务时产生的订单号、订单金额、支付时间、支付结果等信息，用于订单管理、交易对账与售后处理。<strong
          >我们不收集、不存储您的银行卡号、支付密码等支付凭证信息，支付过程由支付机构独立完成。</strong
        >
      </li>
      <li>
        <strong>收款商户资料（开通在线收款时必要）</strong
        >：您申请开通在线收款功能时，需提供收款人姓名、身份证号码及证件照片、银行卡号、开户行、预留手机号、经营场所等商户进件资料。<strong
          >根据《非银行支付机构监督管理条例》等规定，上述信息将共享给持牌支付机构用于商户身份核验、进件审核与资金结算，详见第四章。</strong
        >
      </li>
    </ul>

    <h3>1.5 智能门锁与设备管理</h3>
    <p>
      您使用智能门锁管理功能时，我们会收集您绑定的设备编号、门锁密码有效期与使用记录、开锁记录等信息，用于为您及您的租客生成、下发和管理门锁密码。该功能为选用功能，您不使用时我们不会收集上述信息。
    </p>

    <h3>1.6 客服、反馈与业务通知</h3>
    <ul>
      <li>
        <strong>反馈信息</strong
        >：您通过“意见反馈”提交的问题描述、截图以及您留下的联系方式，用于处理与回复您的诉求。
      </li>
      <li>
        <strong>短信通知</strong
        >：经您触发，我们会通过短信服务向您或您指定的租客发送验证码、账单提醒、合同签署链接等业务通知，为此需将接收方手机号码及通知内容共享给短信服务提供商。
      </li>
    </ul>

    <h3>1.7 智能模板生成（选用功能）</h3>
    <p>
      您使用合同模板智能生成、文本润色等AI辅助功能时，我们会将<strong
        >您主动提交的模板文本内容</strong
      >发送至第三方大模型服务提供商用于生成结果。<strong
        >请您在使用该功能时避免输入与生成需求无关的个人敏感信息。</strong
      >该功能为选用功能，您不使用时不会产生任何数据传输。
    </p>

    <h3>1.8 设备信息、网络与日志信息</h3>
    <ul>
      <li>
        <strong>设备信息（必要）</strong
        >：设备品牌、设备型号、操作系统类型及版本、App版本号，用于版本更新检测、机型适配、故障排查与账号安全保障。
      </li>
      <li>
        <strong>网络与日志信息（必要）</strong
        >：IP地址、网络类型、访问时间、功能操作记录，用于保障网络请求正常、排查服务异常、防范违规与安全风险。您可在“我的-设置-操作日志”中查看您的操作记录。
      </li>
      <li>
        <strong
          >我们自身不收集您的IMEI、IMSI、MEID、Android ID、OAID、MAC地址、设备序列号等设备唯一标识符，亦不会读取您的通讯录、短信、通话记录、应用安装列表或位置信息。</strong
        >但请您注意，<strong
          >本App接入的第三方SDK在您触发对应功能时会在本机读取并向其服务器传输上述部分设备标识符（其中包括OAID、Android
          ID），具体范围、目的及去向请见第四章“第三方SDK信息共享清单”。</strong
        >
      </li>
    </ul>

    <h3>1.9 征得授权同意的例外</h3>
    <p>
      根据《中华人民共和国个人信息保护法》等法律法规，以下情形中我们处理您的个人信息无需征得您的授权同意：
    </p>
    <ul>
      <li>为订立、履行您作为一方当事人的合同所必需，或按照依法制定的劳动规章制度实施人力资源管理所必需的；</li>
      <li>为履行法定职责或者法定义务所必需的；</li>
      <li>为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需的；</li>
      <li>为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息的；</li>
      <li>依照法律规定在合理的范围内处理您自行公开或者其他已经合法公开的个人信息的；</li>
      <li>法律、行政法规规定的其他情形。</li>
    </ul>

    <h2>二、我们如何调用设备权限</h2>
    <p>
      为实现相应功能，本App会在您使用具体功能时<strong
        >单独弹窗向您申请</strong
      >以下权限。<strong
        >您有权随时在设备的系统设置中关闭任一权限，关闭后对应功能将无法使用，但不影响您使用其他功能。</strong
      >
    </p>

    <div class="table-wrap">
      <table class="c-table">
        <thead>
          <tr>
            <th>权限</th>
            <th>对应功能</th>
            <th>使用说明</th>
            <th>是否可关闭</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>相机</td>
            <td>拍摄房源与凭证照片、拍摄证件进行本机离线识别、签署合同时的人脸核验</td>
            <td>仅在您点击拍摄或发起核验时调用，不会在后台开启</td>
            <td>是</td>
          </tr>
          <tr>
            <td>麦克风</td>
            <td>电子合同签署过程中的人脸活体核验</td>
            <td>仅在核验页面内调用，不会在后台录音，不会采集与核验无关的音频</td>
            <td>是</td>
          </tr>
          <tr>
            <td>相册 / 存储</td>
            <td>从相册选择图片上传，保存App内生成的图片、账单与合同文件</td>
            <td>仅读取您主动选择的文件，不会扫描或读取其他相册内容</td>
            <td>是</td>
          </tr>
          <tr>
            <td>剪贴板</td>
            <td>复制客服微信号、房源分享链接、订单号等</td>
            <td><strong>仅在您点击“复制”时写入，我们不读取、不上传您剪贴板中的任何内容</strong></td>
            <td>是</td>
          </tr>
          <tr>
            <td>网络访问</td>
            <td>数据同步与业务请求</td>
            <td>App运行的基础权限</td>
            <td>否</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h2>三、我们如何使用Cookie及同类技术</h2>
    <p>
      为保障App正常运行、提升访问效率，我们会在您的设备本地存储登录凭证、偏好设置、图片缓存等信息。本App部分页面（如电子合同签署页）以内嵌网页形式呈现，该等页面可能使用Cookie及同类技术。<strong
        >我们不会将Cookie用于本政策所述目的之外的用途。</strong
      >您可以通过“我的-设置-退出登录”清除本地登录凭证，或在设备系统设置中清除本App的应用数据以清除本地缓存。
    </p>

    <h2>四、我们如何共享、转让、公开披露您的个人信息</h2>

    <h3>4.1 共享</h3>
    <p>
      我们不会与任何公司、组织和个人共享您的个人信息，但以下情形除外：在获得您的明确同意后共享；在法定情形下共享；以及为实现本政策所述功能，与下列合作方共享实现该功能所<strong>必需</strong>的个人信息。
    </p>
    <p>
      <strong>【重要提示】</strong
      >下列第三方SDK在您同意本政策后方会初始化，并在您触发对应功能时，<strong
        >在您的设备本机读取并直接向其服务器传输设备标识信息（其中支付宝SDK、微信SDK会读取并传输您的OAID、Android
        ID等设备标识符）</strong
      >，该过程中我们不接触、不存储上述信息。请您在使用相关功能前一并阅读其隐私政策。
    </p>

    <h4>4.1.1 第三方SDK信息共享清单</h4>
    <div class="table-wrap">
      <table class="c-table">
        <thead>
          <tr>
            <th>SDK名称</th>
            <th>第三方主体</th>
            <th>使用目的</th>
            <th>收集并传输的个人信息</th>
            <th>收集方式与时机</th>
            <th>隐私政策</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>支付宝支付SDK</td>
            <td>支付宝（中国）网络技术有限公司</td>
            <td>
              用于您购买会员及增值服务时发起支付宝支付；保障支付与账户资金安全、进行交易风险识别与防控，并履行反洗钱、反电信网络诈骗等法定义务
            </td>
            <td>
              <strong>设备标识信息：Android ID、OAID、IMEI、IMSI、MEID、设备序列号、MAC地址</strong
              >（具体字段以您的系统版本及授权情况为准）；设备品牌与型号、操作系统类型及版本；IP地址、网络类型、运营商信息；应用包名、版本号、支付宝客户端是否已安装
            </td>
            <td>
              仅在您点击“支付宝支付”触发支付流程时，由SDK在本机收集并直接传输至支付宝服务器；您未使用支付功能时不会收集
            </td>
            <td>
              <a href="https://opendocs.alipay.com/common/02kiq3" target="_blank"
                >opendocs.alipay.com/common/02kiq3</a
              >
            </td>
          </tr>
          <tr>
            <td>微信开放平台SDK</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>用于将房源信息、账单、图片等分享至微信好友或朋友圈</td>
            <td>
              <strong>设备标识信息：Android ID、OAID、IMEI等</strong
              >（具体字段以系统版本及授权情况为准）；设备品牌与型号、操作系统版本、网络状态、微信客户端是否已安装及其版本
            </td>
            <td>
              仅在您点击分享并唤起微信时，由SDK在本机收集并传输至腾讯服务器
            </td>
            <td>
              <a
                href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
                target="_blank"
                >微信开放平台隐私保护指引</a
              >
            </td>
          </tr>
          <tr>
            <td>阿里云号码认证SDK</td>
            <td>阿里云计算有限公司</td>
            <td>
              用于“本机号码一键登录”，经您授权后向运营商取号并校验本机手机号码
            </td>
            <td>
              本机手机号码（以掩码展示，取号结果以令牌形式返回）、IP地址、设备制造商、设备型号、操作系统类型及版本、SIM卡状态、运营商类型、网络类型
            </td>
            <td>
              仅在您点击“本机号码一键登录”时由SDK在本机收集，并传输至阿里云及相应运营商（中国移动/中国联通/中国电信）认证服务；您使用其他登录方式时不会收集
            </td>
            <td>
              <a
                href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html"
                target="_blank"
                >阿里云隐私权政策</a
              >
            </td>
          </tr>
          <tr>
            <td>Google ML Kit 文字识别SDK</td>
            <td>Google LLC</td>
            <td>识别您拍摄或选择的证件、水电表等图片中的文字，减少手动录入</td>
            <td>
              <strong>不收集、不上传任何个人信息。</strong
              >识别模型已随App内置，识别全过程在您的设备本地离线完成，图片与识别结果不会传输给Google
            </td>
            <td>仅在您主动使用拍照识别功能时于本机调用</td>
            <td>
              <a href="https://developers.google.com/ml-kit/terms" target="_blank"
                >developers.google.com/ml-kit/terms</a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <h4>4.1.2 其他合作方信息共享清单</h4>
    <div class="table-wrap">
      <table class="c-table">
        <thead>
          <tr>
            <th>合作方</th>
            <th>共享场景</th>
            <th>共享的个人信息</th>
            <th>共享方式</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>杭州天谷信息科技有限公司（e签宝）</td>
            <td>电子合同签署、实名认证与人脸核验、合同存证</td>
            <td>
              签署方姓名、手机号码、身份证号码、合同文本内容、电子签名图像；<strong
                >人脸信息由其在核验页面内单独征得您同意后直接采集，我们不接触、不存储</strong
              >
            </td>
            <td>您发起签署或实名认证时，由我们的服务器或其页面按最小必要原则传输</td>
          </tr>
          <tr>
            <td>阿里云计算有限公司（短信服务）</td>
            <td>发送验证码、账单提醒、合同签署链接等业务短信</td>
            <td>接收方手机号码、短信内容</td>
            <td>您触发发送时，由我们的服务器传输</td>
          </tr>
          <tr>
            <td>云服务与存储服务提供商</td>
            <td>服务器托管、数据库与文件存储、内容分发</td>
            <td>为提供服务所必需处理的数据</td>
            <td>
              受托处理，其仅按我们的指示处理数据，无独立使用权，且不得用于其他用途
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      我们仅会共享为实现相应功能所必需的最少个人信息，并与上述合作方签署严格的数据保护协议，要求其按照本政策以及相关保密和安全措施处理个人信息。<strong
        >如您不同意上述共享，您可以选择不使用对应功能；您亦可通过第十章的联系方式要求撤回相关授权。撤回后您将无法使用依赖该合作方的功能，但不影响撤回前基于您的授权已进行的个人信息处理活动的效力。</strong
      >
    </p>
    <p>
      上述清单可能因第三方版本升级、业务调整而变化，我们会及时更新本清单并向您提示。您也可在App内“我的-关于我们-第三方信息共享清单”查看最新清单，并在“我的-关于我们-个人信息收集清单”查看个人信息收集情况。
    </p>

    <h3>4.2 转让</h3>
    <p>
      我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：取得您的明确同意；或涉及合并、收购、资产转让或类似交易时，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该等主体重新向您征求授权同意。
    </p>

    <h3>4.3 公开披露</h3>
    <p>
      我们仅会在取得您明确同意，或基于法律法规、法律程序、诉讼或政府主管部门强制性要求的情况下，公开披露您的个人信息。
    </p>

    <h3>4.4 共享、转让、公开披露的例外情形</h3>
    <p>
      根据相关法律法规及国家标准，以下情形中我们共享、转让、公开披露您的个人信息无需事先征得您的授权同意：与国家安全、国防安全直接相关的；与公共安全、公共卫生、重大公共利益直接相关的；与犯罪侦查、起诉、审判和判决执行等直接相关的；出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；您自行向社会公众公开个人信息的；从合法公开披露的信息中收集个人信息的。
    </p>

    <h2>五、我们如何存储您的个人信息</h2>
    <h3>5.1 存储地域</h3>
    <p>
      我们在中华人民共和国境内运营中收集和产生的个人信息，存储于中国境内。<strong
        >目前我们不会将您的个人信息向境外传输。</strong
      >如未来确需跨境传输，我们将依法另行向您告知出境的目的、接收方、信息类型、安全保障措施及风险，并取得您的单独同意，同时依法履行安全评估或认证等程序。
    </p>

    <h3>5.2 存储期限</h3>
    <ul>
      <li>
        账号信息（手机号、密码、昵称、头像）：在您使用本App期间持续保存；<strong
          >您通过“删除账号”注销后，我们将即时从生产数据库中删除，备份数据将在备份轮换周期内清除。</strong
        >
      </li>
      <li>
        房源、租客、合同、账单等业务数据：在您使用本App期间持续保存，以便您随时查询；账号删除后即时清空，法律法规要求留存的除外。
      </li>
      <li>
        <strong
          >交易与支付记录：根据《中华人民共和国电子商务法》《非银行支付机构监督管理条例》等规定，自交易完成之日起保存不少于3年；</strong
        >电子合同及相关存证信息，根据《电子签名法》等规定保存至法定期限届满。该等信息即使在您注销账号后仍需依法留存，我们将采取严格的访问控制措施。
      </li>
      <li>
        操作日志与安全日志：根据《网络安全法》规定，相关网络日志留存不少于6个月。
      </li>
    </ul>

    <h3>5.3 产品或服务停止运营时的处理</h3>
    <p>
      当本App停止运营时，我们将以推送通知、公告等形式至少提前30日通知您，并在停止运营后停止收集个人信息，同时在合理期限内删除您的个人信息或进行匿名化处理，法律法规另有规定的除外。
    </p>

    <h2>六、我们如何保护您的个人信息</h2>
    <ul>
      <li>
        <strong>技术措施</strong
        >：我们采用符合业界标准的安全防护措施，包括传输链路TLS/SSL加密、密码不可逆加密存储、身份证号等敏感信息加密存储与脱敏展示、访问鉴权与最小权限控制等。
      </li>
      <li>
        <strong>管理措施</strong
        >：我们建立了数据安全管理制度，对可能接触到个人信息的工作人员进行权限分级与最小化授权，签署保密协议并开展安全与隐私保护培训。
      </li>
      <li>
        <strong>安全事件响应</strong
        >：若不幸发生个人信息安全事件，我们将按照法律法规要求，及时以推送通知、公告或其他合理方式向您告知事件基本情况、可能影响、我们已采取的处置措施与您可采取的补救建议，并按规定向主管部门报告。
      </li>
      <li>
        <strong
          >请您理解，互联网环境并非百分之百安全。请您妥善保管账号与密码，不要将验证码告知他人；如发现账号异常，请立即通过第十章的方式联系我们。</strong
        >
      </li>
    </ul>

    <h2>七、您的权利</h2>
    <p>我们保障您对自己的个人信息行使以下权利：</p>
    <ul>
      <li>
        <strong>查阅与复制</strong
        >：您可在“我的-个人信息”中查阅账号信息，在“我的-设置-操作日志”中查阅操作记录，在各业务模块中查阅您录入的业务数据。您也可通过第十章的联系方式申请获取个人信息副本。
      </li>
      <li>
        <strong>更正与补充</strong
        >：您可在“我的-个人信息”中更正昵称、头像等信息，在“我的-设置-账号与安全-更换手机号”中变更手机号码，在相应业务页面更正房源、租客、合同等信息。
      </li>
      <li>
        <strong>删除</strong
        >：您可自行删除您录入的房源、租客、合同、账单等信息，也可通过“我的-设置-账号与安全-删除账号”一次性清空全部数据。以下情形中，您可要求我们删除您的个人信息：处理目的已实现或为实现目的不再必要；我们停止提供产品或服务；您撤回同意；我们违反法律法规或约定处理您的个人信息。
      </li>
      <li>
        <strong>撤回同意</strong
        >：您可通过设备系统设置关闭相机、麦克风、相册等权限以撤回相应授权；可通过不使用对应功能撤回对第三方SDK共享的同意；也可通过第十章的方式向我们提出撤回请求。<strong
          >撤回同意不影响撤回前基于您的同意已进行的个人信息处理活动的效力。</strong
        >
      </li>
      <li>
        <strong>注销账号</strong
        >：您可在“我的-设置-账号与安全-删除账号”中自助注销您的账号，无需人工审核，确认后即时生效。<strong
          >账号一经删除不可恢复：您的账号信息及您所在组织的房源、租客、合同、账单等全部业务数据将被清空，若您是组织的超级管理员，该组织及组织下所有成员账号亦将一并删除。请您谨慎操作，并提前通过“我的-设置-数据导入导出”导出所需数据。</strong
        >法律法规要求留存的交易记录、电子合同存证及网络日志，我们将依照第5.2条继续留存至法定期限届满，并采取严格的访问控制措施。
      </li>
      <li>
        <strong>可携带</strong
        >：在符合国家网信部门规定条件的情况下，您可要求我们将您的个人信息转移至您指定的个人信息处理者。
      </li>
      <li>
        <strong>解释说明</strong
        >：您有权要求我们对本政策进行解释说明。<strong
          >本App未使用个人信息进行自动化决策或个性化推送，亦未向您定向推送商业广告。</strong
        >
      </li>
      <li>
        <strong>逝者权利</strong
        >：自然人死亡的，其近亲属为自身合法、正当利益，可对逝者的相关个人信息行使查阅、复制、更正、删除等权利，法律另有安排的除外。
      </li>
    </ul>
    <p>
      为保障安全，我们可能要求您验证身份后再处理您的请求。<strong
        >我们将在收到您的请求之日起15个工作日内予以答复。</strong
      >对于您的合理请求，我们原则上不收取费用；对多次重复、超出合理限度的请求，我们可能收取一定成本费用或予以拒绝并说明理由。
    </p>

    <h2>八、我们如何处理未成年人的个人信息</h2>
    <p>
      <strong>本App面向房屋出租经营者提供服务，不适用于未成年人使用。</strong
      >我们不会主动向未成年人收集个人信息。若您是未满18周岁的未成年人，请在监护人的陪同下阅读本政策，并在取得监护人明确同意后使用本App。<strong
        >若您是不满14周岁儿童的监护人，我们在收集儿童个人信息前会取得您的单独同意，并依照《儿童个人信息网络保护规定》等要求处理。</strong
      >如我们发现在未事先取得可证实的监护人同意的情况下收集了未成年人的个人信息，将设法尽快删除相关信息。
    </p>

    <h2>九、本政策如何更新</h2>
    <p>
      我们可能适时修订本政策。未经您明确同意，我们不会削减您按照本政策所应享有的权利。
    </p>
    <p>
      <strong
        >对于重大变更（如业务功能或处理目的发生重大变化、共享或转让的第三方范围发生变化、个人信息处理者的联系方式发生变化、个人信息安全影响评估报告表明存在高风险等），我们将通过App内弹窗、显著位置公告或推送通知等方式另行提示，并在必要时重新征得您的同意。</strong
      >
    </p>
    <p>
      您可在“我的-关于我们-隐私协议”中随时查阅本政策的最新版本。若您在本政策更新生效后继续使用本App，即表示您已充分阅读、理解并接受更新后的政策。
    </p>

    <h2>十、如何联系我们</h2>
    <ul>
      <li><strong>个人信息处理者</strong>：马鞍山市微行网络科技有限责任公司</li>
      <li><strong>App名称</strong>：寓喵管家</li>
      <li><strong>备案编号</strong>：皖ICP备2023010886号-2A</li>
      <li><strong>联系电话</strong>：17355531499</li>
      <li>
        <strong>App内渠道</strong>：“我的-设置-联系客服”“我的-意见反馈”
      </li>
    </ul>
    <p>
      如您对本政策或个人信息保护有任何疑问、意见、投诉或建议，可通过上述方式与我们联系，我们将在收到后15个工作日内予以答复。
    </p>
    <p>
      <strong
        >如您认为我们的个人信息处理行为损害了您的合法权益，且与我们协商未能解决的，您还可以向网信、电信、公安及市场监管等主管部门投诉举报，或向被告住所地有管辖权的人民法院提起诉讼。</strong
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "privacy",
};
</script>

<style>
.content {
  color: #333;
  background: #fff;
  line-height: 28px;
  padding: 20px;
  font-size: 15px;
  word-break: break-word;
}

.content h1 {
  font-size: 20px;
  text-align: center;
  margin: 10px 0 16px;
  color: #222;
}

.content h2 {
  font-size: 17px;
  margin: 24px 0 10px;
  color: #222;
  border-left: 4px solid #2d8cf0;
  padding-left: 8px;
}

.content h3 {
  font-size: 15px;
  margin: 18px 0 8px;
  color: #222;
}

.content h4 {
  font-size: 14px;
  margin: 14px 0 6px;
  color: #444;
}

.content p {
  margin: 8px 0;
}

.content ul {
  padding-left: 20px;
  margin: 8px 0;
}

.content li {
  margin: 6px 0;
}

.content a {
  color: #2d8cf0;
  word-break: break-all;
}

.meta {
  color: #888;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  margin-bottom: 16px;
}

.tip {
  background: #f7f9fb;
  border: 1px solid #e6ebf0;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 8px;
}

.toc {
  color: #555;
  font-size: 14px;
}

.table-wrap {
  overflow-x: auto;
  margin: 10px 0 14px;
  -webkit-overflow-scrolling: touch;
}

.c-table {
  border-collapse: collapse;
  font-size: 13px;
  line-height: 21px;
  min-width: 100%;
}

.c-table th,
.c-table td {
  border: 1px solid #dfe3e8;
  padding: 8px;
  text-align: left;
  vertical-align: top;
  min-width: 110px;
}

.c-table th {
  background: #f2f5f8;
  color: #222;
  white-space: nowrap;
}
</style>
